import { render, staticRenderFns } from "./Tableview.vue?vue&type=template&id=1b15ba83&"
import script from "./Tableview.js?vue&type=script&lang=js&"
export * from "./Tableview.js?vue&type=script&lang=js&"
import style0 from "./Tableview.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports